var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#2E7D32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4111 16.9609V18H9.89648V17.0908L13.1572 13.4609C13.5583 13.0143 13.8682 12.6361 14.0869 12.3262C14.3102 12.0117 14.4652 11.7314 14.5518 11.4854C14.6429 11.2347 14.6885 10.9795 14.6885 10.7197C14.6885 10.3916 14.6201 10.0954 14.4834 9.83105C14.3512 9.56217 14.1553 9.34798 13.8955 9.18848C13.6357 9.02897 13.3213 8.94922 12.9521 8.94922C12.5101 8.94922 12.141 9.03581 11.8447 9.20898C11.5531 9.3776 11.3343 9.61458 11.1885 9.91992C11.0426 10.2253 10.9697 10.5762 10.9697 10.9727H9.70508C9.70508 10.4121 9.82812 9.89941 10.0742 9.43457C10.3203 8.96973 10.6849 8.60059 11.168 8.32715C11.651 8.04915 12.2458 7.91016 12.9521 7.91016C13.5811 7.91016 14.1188 8.02181 14.5654 8.24512C15.012 8.46387 15.3538 8.77376 15.5908 9.1748C15.8324 9.57129 15.9531 10.0361 15.9531 10.5693C15.9531 10.861 15.903 11.1572 15.8027 11.458C15.707 11.7542 15.5726 12.0505 15.3994 12.3467C15.2308 12.6429 15.0326 12.9346 14.8047 13.2217C14.5814 13.5088 14.3421 13.7913 14.0869 14.0693L11.4209 16.9609H16.4111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondStep);
export default __webpack_public_path__ + "static/media/_Second_Step_.0927d6e86870e20a04c4a9d7866a31b1.svg";
export { ForwardRef as ReactComponent };